import BasePageView from "components/core/BasePageView/BasePageView";
import useSellerContext from "hooks/useSellerContext";
import usePurchaseOrderDetailsLogic from "./usePurchaseOrderDetailsLogic";
import PoDetailsDesktop from "./PoDetailsDesktop";
import PoDetailsMobile from "./PoDetailsMobile";

const PoDetailsView = () => {
  const vm = usePurchaseOrderDetailsLogic();
  const { currentSellerDetail, allSellersDetails, handleProfileNavigate } = useSellerContext();

  return (
    <BasePageView
      DesktopView={PoDetailsDesktop}
      MobileView={PoDetailsMobile}
      viewProps={vm}
      headerProps={{
        showSubHeader: true,
        sellerDetail: currentSellerDetail,
        allSellerDetails: allSellersDetails,
        handleProfile: handleProfileNavigate,
      }}
    />
  );
};

export default PoDetailsView;
